import React from 'react'
import { Row, Col } from 'react-bootstrap'
import styles from './index.module.css'
import { Link } from 'react-router-dom'

type Props = {
  contactName: string
  address: string
  id: string
}

function ContactItem({ contactName, address, id }: Props) {
  return (
    <Col
      xs={12}
      className={`${styles.contactCard} `}
      data-testid="contact-card"
    >
      <Row className="py-3" noGutters={true}>
        <Col xs={10} className="align-self-center">
          <h4 className={styles.removePadding}>{contactName}</h4>
          <p className={styles.removePadding}>
            {address.substring(0, 20)}{' '}
            {address.length > 20 ? <span>...</span> : null}
          </p>
        </Col>
        <Col xs={2} className="align-self-center text-right float-right">
          <Link to={`/recipients/${id}`}>
            <img
              src="/icons/icon-edit.svg"
              alt="icon-edit"
              width="24px"
              height="24px"
            />
          </Link>
        </Col>
      </Row>
    </Col>
  )
}

export default ContactItem
